import React, { useState, useEffect } from "react";
import "./index.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { Link, useRoutes } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import prescriptionAvatar from "../icons/prescription.jpg";
import Checkbox from "@mui/material/Checkbox";
import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import axios from "axios";
import DefaultTextInput from "components/common/DefaultTextInput/DefaultTextInput";
import useUser from "../../../context/user/useUser";
import { getToken } from "../../../auth/authenticate";
import { api } from 'services/ApiService';

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#ffffff",
  color: "#8f8f8f",
  boxShadow: "1px 1px 1px 1px #d1d1d1",
  // '&:hover': {
  //   backgroundColor: alpha(theme.palette.common.white, 0.25),
  // },
  marginRight: theme.spacing(2),
  width: "100%",
  height: "50px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(5),
    width: "70%",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1.5, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "30ch",
    },
  },
}));

//send modal
const SendDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const SendDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
    </DialogTitle>
  );
};

SendDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export const AddMoreInfo = () => {
  const { settings } = useUser();
  const user_id = settings.userId; //logged user ID
  const navigate = useNavigate();
  const locations = useLocation();
  const [sendDialogOpen, setSendDialogOpen] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  const [prescName, setPrescName] = useState();
  const [selectName, setSelectName] = useState([]);
  const [selectedPrescIds, setSelectedPrescIds] = useState([]);
  const [input, setinput] = useState("");

  const [phoneNO, setPhoneNO] = useState("");
  const [dob, setDob] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [orderId, setOrderId] = useState("");
  // const [prescriptions, setPrescriptions] = useState(selectName);
  const [errors, setErrors] = useState([]);
  const [prescriptions, setPrescriptions] = useState([]);

  const pharmacyId = locations.pathname.split("/")[3];

  const handleselectedName = (id,name,isChecked) => {
    if (isChecked) {
      setSelectName((old) => [...old, name]);
      setSelectedPrescIds((old) => [...old, id]);
    } else {
      selectName.splice(selectName.indexOf(name), 1);
      setSelectName(selectName);
      selectedPrescIds.splice(selectedPrescIds.indexOf(id), 1);
      setSelectedPrescIds(selectedPrescIds);
    }
    
  };

  const handleRemoveFile = (ind) => {
    const list = [...selectName];
    list.splice(ind, 1);
    setSelectName(list);
    if (selectedPrescIds[ind]) {
      document.getElementById(`${selectedPrescIds[ind]}_box`).click();
    }
    const list1 = [...selectedPrescIds];
    list1.splice(list1.indexOf(selectedPrescIds[ind]), 1);
    setSelectedPrescIds(list1);
  };

 
  const validate = () => {
    const errors = {};
    let errs = [];
    if (!email) {
      errors.email = "Email is required";
      errs.push("Email is required");
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      errors.email = "Invalid email address";
      errs.push("Invalid email address");
    }

    if (!phoneNO) {
      errors.phone = "Phone Number is required";
      errs.push("Phone Number is required");
    }
    if (!dob) {
      errors.dob = "Date of Birth is required";
      errs.push("Date of Birth is required");
    }
    if (!address) {
      errors.address = "Address is required";
      errs.push("Address is required");
    }

    if (selectedPrescIds.length===0) {
      errors.prescription = "At least select one prescription";
      errs.push("At least select one prescription");
    }
    setErrors(errs);
    return errs;
  };

  const createOrder = async () => {
    if (validate().length > 0) {
      return;
    }
    let data={
      pharmacyId: pharmacyId,
      email: email,
      phoneNumber: phoneNO,
      name: userInfo?.name,
      address: address,
      dob: dob,
      prescriptions: selectedPrescIds || [],
    }
    const result =  await api(`${process.env.REACT_APP_BACKEND_URL}pharmacy-order/patient`, 'POST',null,data);

    if (result) {
      setOrderId(result?.data?.pharmacyOrderId);
      setSendDialogOpen(true);
    }
  };

  const handleSendDialogClose = () => {
    setSendDialogOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {

      const result =  await api(`${process.env.REACT_APP_BACKEND_URL}user/patient/${user_id}`, 'GET');
      setUserInfo(result?.data);
      setPhoneNO(result?.data?.User?.phoneNumber);
      setDob(result?.data?.dob);
      setAddress(result?.data?.address);
      setEmail(result?.data?.User?.email);
    };
    fetchData();
    prescriptionsData();
  }, []);

  const prescriptionsData = async () => {
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}prescription/patient`, config);
    setPrescriptions(result?.data.data);
  };

  return (
    <>
      {/* send Dialog */}
      <div>
        <SendDialog
          onClose={handleSendDialogClose}
          aria-labelledby="customized-dialog-title"
          open={sendDialogOpen}
        >
          <DialogContent className="sendDialogInfoContent">
            <img
              alt="tick icon"
              src="https://cdn.pixabay.com/photo/2017/09/02/07/33/social-2706548_960_720.png"
              width={90}
              height={90}
            ></img>
            <h3>Your Order will Placed</h3>
            <p>Be Pateint For Accept the Order</p>
            <p>The pharmacy will confirm you order within a day</p>
          </DialogContent>
          <DialogActions className="sendDialogInfoAction">
            <Link to="/" className="paymentHistoryLink">
              <Button
                variant="contained"
                onClick={handleSendDialogClose}
                className="SendDialogBtn"
              >
                Back to Home
              </Button>
            </Link>
          </DialogActions>
        </SendDialog>
      </div>

      {/* Main Div */}
      <div className="addMoreInfoMain">
        <Grid container>
          <Grid item xs={5} md={6} lg={7}>
            <div className="pharmacyInfoMainHeading">
              <div onClick={() => navigate(-1)}>
                <ArrowCircleLeftOutlinedIcon
                  className="headingIcon"
                  fontSize="large"
                />
              </div>
              <h3>Add More Information</h3>
            </div>
          </Grid>
          <Grid item xs={5} md={5} lg={4}>
            {/* <Search className="addMoreInfoSearchBox">
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={input}
                onChange={(e) => setinput(e.target.value)}
              />
            </Search> */}
          </Grid>
          <Grid item xs={2} md={1} lg={1}>
            {/* <div className="tuneIcon">
              <TuneOutlinedIcon />
            </div> */}
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            "& > :not(style)": {
              m: 1,
              mr: 2,
              pl: 2,
              pr: 2,
              pb: 2,
              width: "100%",
              height: "auto",
            },
          }}
        >
          <Paper elevation={1}>
            <Grid container>
              <Grid item xs={12} md={5} lg={3}>
                <h4>Fill Information</h4>
                <div className="info1">
                  <div>
                    <h6>Name</h6>
                    <p>{userInfo?.name}</p>
                  </div>
                </div>
                <div className=" info2">
                  <DefaultTextInput
                    title="Date of Birth"
                    type="date"
                    editableText={true}
                    value={dob}
                    placeholder={"Enter Date of Birth"}
                    onChangeValue={(v) => {
                      setDob(v.target.value);
                    }}
                  />
                </div>
                <div className="info2">
                  {/* <div>
                    <h6>Email</h6>
                    <p>{userInfo[0] && userInfo[0].billing_email}</p>
                    <div
                      className="editIcon"
                      onClick={() =>
                        handleEditDialogOpen(
                          "Email",
                          userInfo[0] && userInfo[0].billing_email
                        )
                      }
                    >
                      <EditIcon className="editIconSize" />
                    </div>
                  </div> */}
                  <DefaultTextInput
                    title="Email"
                    editableText={true}
                    value={email}
                    placeholder={"Enter Email"}
                    onChangeValue={(v) => {
                      setEmail(v.target.value);
                    }}
                  />
                </div>
                {/* <div className="info1 info2">
                  <div>
                    <h6>Location</h6>
                    <p>{userInfo[0] && userInfo[0].location}</p>
                  </div>
                </div> */}
                <div className=" info2">
                  <DefaultTextInput
                    title="Contact Number"
                    editableText={true}
                    value={phoneNO}
                    placeholder={"Enter Contact Number"}
                    onChangeValue={(v) => {
                      setPhoneNO(v.target.value);
                    }}
                  />
                </div>
                <div className="info2">
                  <DefaultTextInput
                    title="Address"
                    editableText={true}
                    value={address}
                    placeholder={"Enter address"}
                    onChangeValue={(v) => {
                      setAddress(v.target.value);
                    }}
                  />
                </div>
                <div className="info1 info2 add-presc">
                  <div>
                    <h6>Add Multiple Prescription</h6>
                    {selectName.map((item, index) => {
                      return (
                        <div className="file-name">
                          <FilePresentOutlinedIcon fontSize="small" />
                          <p>{item}.pdf</p>
                          <div
                            className="delete-file"
                            onClick={() => {
                              handleRemoveFile(index);
                            }}
                          >
                            <div>
                              <CloseOutlinedIcon />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} md={7} lg={9}>
                <div className="addMorePres">
                  <h4>Add more Prescription</h4>
                  {(prescriptions || []).map((item, index) => {
                    return (
                      <div key={index} className="addMorePresDetails">
                        <Checkbox
                          id={`${item.prescriptionId}_box`}
                          onClick={(e) =>
                            handleselectedName(
                              item.prescriptionId,
                              item.name,
                              e.target.checked
                            )
                          }
                        />
                        <Stack direction="row" spacing={1}>
                          <Avatar
                            alt="Patient Avatar"
                            src={prescriptionAvatar}
                            variant="rounded"
                            className="addMorePresAvatar"
                          />
                          <div className="addMorePresName">
                            <h5>{item?.name}</h5>
                            <p>{item?.Doctor?.name}</p>
                            <p>{item?.createdAt?.split("T")[0]}</p>
                          </div>
                        </Stack>
                      </div>
                    );
                  })}
                  {prescriptions?.length === 0 ? (
                    <h5 style={{ textAlign: "center", marginTop: "50px" }}>
                      Please Make an appointment before making an order!
                    </h5>
                  ) : null}
                </div>
              </Grid>
            </Grid>
            {errors?.map((item, index) => (
              <span
                style={{
                  color: "red",
                  fontSize: "12px",
                  fontWeight: "500",
                  marginBottom: "20px",
                }}
              >
                {item}
                <br />
              </span>
            ))}
            <Button
              variant="contained"
              className="addMoreInfobtn"
              onClick={createOrder}
            >
              Done
            </Button>
          </Paper>
        </Box>
      </div>
    </>
  );
};
